import { Component, Inject, OnInit, Optional } from '@angular/core';
import { MatBottomSheetRef, MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-confirm-popup',
  templateUrl: './confirm-popup.component.html',
  styleUrls: ['./confirm-popup.component.sass']
})
export class ConfirmPopupComponent implements OnInit {

  public data: any;
  public selfRef: any;

  constructor(
    @Optional() private _dialogRef: MatDialogRef<ConfirmPopupComponent>,
    @Optional() private _sheetRef: MatBottomSheetRef<ConfirmPopupComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public dialogData: any,
    @Optional() @Inject(MAT_BOTTOM_SHEET_DATA) public sheetData: any,
  ) {

    this.selfRef = _dialogRef ? _dialogRef : _sheetRef
    this.data = dialogData ? dialogData : sheetData

  }

  ngOnInit(): void {
  }


  public close(action: boolean) {
    try { this.selfRef.close(action) } catch { this.selfRef.dismiss(action) }
  }

}
